import { CORE_SPREAD_DEFINITIONS, type SpreadDefinition } from '../definitions/core';
import { DECISION_SPREAD_DEFINITIONS } from '../definitions/decision';
import { KABBALISTIC_SPREAD_DEFINITIONS } from '../definitions/kabbalistic';
import { LILITH_SPREAD_DEFINITIONS } from '../definitions/lilith';
import { RELATIONAL_SPREAD_DEFINITIONS } from '../definitions/relational';
import { SHADOW_SPREAD_DEFINITIONS } from '../definitions/shadow';
import { SPIRITUAL_SPREAD_DEFINITIONS } from '../definitions/spiritual';
import { TEMPORAL_SPREAD_DEFINITIONS } from '../definitions/temporal';

const dedupeBySlug = (definitions: SpreadDefinition[]): SpreadDefinition[] => {
  const registry = new Map<string, SpreadDefinition>();

  for (const definition of definitions) {
    registry.set(definition.spread.slug, definition);
  }

  return Array.from(registry.values());
};

export const ALL_SPREAD_DEFINITIONS: SpreadDefinition[] = dedupeBySlug([
  ...CORE_SPREAD_DEFINITIONS,
  ...RELATIONAL_SPREAD_DEFINITIONS,
  ...DECISION_SPREAD_DEFINITIONS,
  ...TEMPORAL_SPREAD_DEFINITIONS,
  ...SHADOW_SPREAD_DEFINITIONS,
  ...SPIRITUAL_SPREAD_DEFINITIONS,
  ...LILITH_SPREAD_DEFINITIONS,
  ...KABBALISTIC_SPREAD_DEFINITIONS,
]);

export const ALL_SPREADS = ALL_SPREAD_DEFINITIONS.map((definition) => definition.spread);
